module.exports = __webpack_public_path__ + "img/awards_medal.13fd72e4.png";